// extracted by mini-css-extract-plugin
export default {"Nav":"BottomNav_Nav__2pb6U","Bar":"BottomNav_Bar__dlkqg","QRButton":"BottomNav_QRButton__VEyHb"};